import { Component } from '@verndale/core';
import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      decorator: this.el.querySelector('.blockquote__decorator img')
    }

    if (this.dom.decorator) {
      this.initShapeAnimation();
    }
  }

  initShapeAnimation() {
    gsap.from(this.dom.decorator, {
      scrollTrigger: {
        trigger: this.el,
        end: 'top 25%',
        scrub: true
      },
      opacity: 0,
      scale: 0.65,
      rotation: -20
    });
  }
}

export default Module;
